<template>
  <v-dialog
    :value="value"
    :max-width="maxWidth"
    overlay-color="var(--ds-color-reverse)"
    @input="closeDialog"
  >
    <v-card>
      <v-toolbar>
        <v-toolbar-title>
          {{ filterTitleLabel }}
        </v-toolbar-title>
        <v-spacer />
        <v-toolbar-items class="align-items-center">
          <span>
            <StIcon
              class="close-icon"
              icon-name="close"
              @click="closeDialog"
            />
          </span>
        </v-toolbar-items>
      </v-toolbar>

      <v-row
        no-gutters
        class="mt-5 mx-5"
      >
        <GlobalFilterSummary
          v-if="showGlobalFilterFeature"
          :global-filter-by-data-type="globalFilterByDataType"
          :data-type="card.dataType"
        />
      </v-row>

      <v-row
        no-gutters
        class="mt-5 mx-5"
      >
        <v-col
          cols="12"
          md="4"
          class="pr-4"
          @scroll.stop
        >
          <ContractFilter
            v-model="tempFilter['contracts']"
            :searchable="true"
            :items="contractFilterItems"
            @input="changeFilterValue()"
            @clearInfo="trackEvent"
          />
        </v-col>

        <v-col
          cols="12"
          md="4"
          class="pr-4"
          @scroll.stop
        >
          <BotFilter
            v-model="tempFilter['bots']"
            :searchable="true"
            :items="botFilterItems"
            @input="changeFilterValue()"
            @clearInfo="trackEvent"
          />
        </v-col>
        <v-col
          v-if="isEventComponent"
          cols="12"
          md="4"
          class="pr-4"
          @scroll.stop
        >
          <CategoryFilter
            v-model="tempFilter['category']"
            @input="changeFilterValue()"
            @clearInfo="trackEvent"
          />
        </v-col>
      </v-row>
      <v-row
        no-gutters
        class="pb-5 px-5"
      >
        <v-spacer />
        <v-spacer />
        <v-btn
          v-if="showClearChanges"
          outlined
          rounded
          class="mr-3"
          @click="clearChangesFilter"
        >
          {{ clearChangeLabel }}
        </v-btn>
        <v-btn
          v-if="showClearFilter"
          outlined
          rounded
          class="mr-3"
          @click="clearFilter"
        >
          {{ clearFilterLabel }}
        </v-btn>
        <v-btn
          outlined
          rounded
          @click="applyFilter"
        >
          {{ applyLabel }}
        </v-btn>
      </v-row>
    </v-card>
  </v-dialog>
</template>

<script>
import StIcon from '@stilingue/st-icon';
import ContractFilter from '@/components/filter/ContractFilter';
import BotFilter from '@/components/filter/BotFilter';
import CategoryFilter from '@/components/filter/CategoryFilter';
import blipFilterModel from '@/mixins/blip-filter-model';
import filtersModel from '@/mixins/filters-model';
import GlobalFilterSummary from '@/components/GlobalFilterSummary';
import { trackEventWithUserProperties } from '@/utils/mixpanel';
import { isEqual } from 'lodash';

import { Flags } from '@/plugins/rollout';
import { mapGetters } from 'vuex';
import { DATA_TYPE } from '@/store/modules/cards/constants';

export default {
  name: 'FilterBlipModal',
  components: {
    StIcon,
    ContractFilter,
    BotFilter,
    CategoryFilter,
    GlobalFilterSummary,
  },
  mixins: [
    blipFilterModel,
    filtersModel,
  ],
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    card: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      filterLabel: 'Filtro Blip',
      applyLabel: 'Aplicar',
      clearFilterLabel: 'Limpar todo o filtro',
      clearChangeLabel: 'Reverter mudanças recentes',
      appliedFilter: {},
      tempFilter: {},
    };
  },
  computed: {
    ...mapGetters('dashboard', [
      'activeDashboardFilters',
    ]),
    ...mapGetters('featureFlag', [
      'isEnabled',
    ]),
    ...mapGetters('user', [
      'isEditor',
    ]),
    showGlobalFilterFeature() {
      return this.isEnabled(Flags.showGlobalFilter) && this.isEditor;
    },
    showClearChanges() {
      return !(isEqual(this.appliedFilter, this.tempFilter)) || this.changeOnPageFilter;
    },
    isEventComponent() {
      return Boolean(this.card?.isEvent);
    },
  },
  watch: {
    'tempFilter.contracts': {
      handler(newContract, oldContract) {
        if (Boolean(oldContract?.value) && newContract.value !== oldContract?.value) {
          delete this.tempFilter.bots;
        }
      },
      deep: true,
    },
  },
  methods: {
    trackEvent(label) {
      trackEventWithUserProperties('ST Card Filter Delete', { Field: label, 'Data Type': DATA_TYPE.BLIP });
    },
    changeFilterValue() {
      this.changeOnPageFilter = true;
    },
  },
};
</script>

<style scoped lang="scss">
  .filter-sac-status-modal {
    line-height: 20px;
    color: var(--ds-color-text-1);
    font-size: var(--ds-font-size-sm);

    &__description {
      font-weight: var(--ds-font-weight-regular);
    }

    &__contrast {
      font-weight: var(--ds-font-weight-bold);
    }
  }

  .align-items-center {
    align-items: center;
  }
</style>
